const Roles = {
  Admin: 'cs_admin',
  Artist: 'artist',
  Moderator: 'moderator',
  HrManager: 'hr_manager',
};

export { Roles };
